import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { TabControl } from '@shared/ui/controls/tab-control.model';
import { TabOptions } from '@shared/interfaces/tab-option.interface'
import { UiColumn } from '@shared/ui/ui-column';
import { RedeploymentOrder } from '@shared/interfaces/entities/redeployment-order.interface';
import { SubToolbarItem, ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faPlus, faSearch, faCircleArrowRight, faShip, faShippingFast, faCancel, faCheck, faRemove } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { INotificationService } from '../../../shared/services/inotification.service';
import { EntityService } from '../../../shared/services/entity.service';
import { FeedbackMessageService } from '../../../shared/services/feedback-message.service';
import { DetailService } from '../../../core/services/detail.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseComponent } from '../../../core/models/base-component.model';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { SVGIcon, arrowUpIcon, arrowDownIcon, trashIcon, saveIcon, xIcon, clipboardIcon } from '@progress/kendo-svg-icons';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { throwError } from 'rxjs';
import { GetOrganizationServicesService } from '../../../core/services/get-services.service';
import { RedeploymentOrderStatus, Services } from '../../../shared/literals/shared.literal';
import { Permission } from '@core/literals/permission.literal';
import { ViewControl } from '../../../shared/ui/controls/view-control.model';
import { UiGroupControl } from '../../../shared/ui/controls/ui-group-control.model';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { ReadOnlyIf, ReadOnlyProperty, RequiredIf, VisibleProperty } from '../../../shared/ui/control-options/control-option.interface';
import { EditorControl } from '../../../shared/ui/controls/editor-control.model';
import { GridControl } from '../../../shared/ui/controls/grid-control.model';
import { ViewRowControl } from '../../../shared/ui/controls/view-row-control.model';
import { EditorComponent } from '@progress/kendo-angular-editor';
import { StateSelect } from '../../../shared/ui/select-controls/state-select.model';
import { CountrySelect } from '../../../shared/ui/select-controls/country-select.model';
import { BaseDetailForm } from '../../../shared/ui/base-detail-form';
import { RedeploymentOrderService } from '../services/redeployment-order.service';
import { TextAreaControl } from '../../../shared/ui/controls/textarea-control.model';
import { CountryFilter } from '../../../shared/interfaces/select-filters/country-filter.interface';
import { StateFilter } from '../../../shared/interfaces/select-filters/state-filter.interface';
import { OnChangeArgs } from '../../../shared/components/select-field/select-field.component';
import { ListBoxControl } from '../../../shared/ui/controls/listbox-control.model';
import { CellClickEvent, GridComponent, PagerSettings, RowArgs, SelectableSettings } from '@progress/kendo-angular-grid';
import { Item } from '../../../shared/interfaces/entities/item.interface';
import { GridDataBindingDirective } from '../../../shared/directives/grid-data-binding.directive';
import { ContextMenuComponent, ContextMenuSelectEvent } from '@progress/kendo-angular-menu';
import { ContextMenuItem } from '../../../shared/interfaces/contex-menu-item.interface';
import { State, process } from '@progress/kendo-data-query';
import { Clipboard } from '@angular/cdk/clipboard';
import { WindowService, WindowSettings } from '@progress/kendo-angular-dialog';
import { CancelRequestComponent } from '../../../shared/components/cancel-request/cancel-request.component';
import { BooleanResult } from '../../../core/interfaces/boolean-result.interface';
import { AddItemsComponent } from '../add-items/add-items.component';
import { RemoveItemsComponent } from '../remove-items/remove-items.component';

@Component({
    selector: 'app-redeployment-order',
    templateUrl: './redeployment-order.component.html',
    styleUrls: ['./redeployment-order.component.css'],
    standalone: false
})
export class RedeploymentOrderComponent extends BaseDetailForm<RedeploymentOrder> implements OnInit {

  @Output() @ViewChild("editor") public editor: EditorComponent;
  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  @ViewChild(GridDataBindingDirective) db: GridDataBindingDirective;
  @ViewChild('grid') public orderGrid: GridComponent;
  @ViewChild("gridMenu") public gridContextMenu: ContextMenuComponent;
  contextMenuItems: ContextMenuItem[] = [];

  id: string;

  detailForm: FormGroup;
  formControls: { [k: string]: FormControl } = {};
  submitted: boolean = false;
  toolbarItem: ToolbarItem[] = [];

  public svgUpArrow: SVGIcon = arrowUpIcon;
  public svgDownArrow: SVGIcon = arrowDownIcon;
  public svgTrash: SVGIcon = trashIcon;

  openCancelDialog: boolean = false;
  openShipDialog: boolean = false;

  dialogNo: SVGIcon = xIcon;
  dialogYes: SVGIcon = saveIcon;
  dialogLoader: boolean = false;
  dialogIcon: boolean = true;

  updateOrderPermission: boolean;
  updateTrackingNumbers: boolean;
  canCancelOrder: boolean;
  canShipOrder: boolean;

  selectedRow?: Item;
  public lastSelectedColumnName: number;
  public lastSelectedItem: any;
  public mySelection: number[] = [];
  public lastSelectedRowIndex: number;
  public lastPointerEvent: PointerEvent;
  private rowIndex: any;
  private rowId: string;
  private contextItem: any;
  public showCommandRow: boolean = false;

  itemUniqnumList: any[] = [];

  gridState: State = { sort: [], skip: 0, take: 1000 }
  public state: State = { skip: 0, take: 100 };

  public pageSize: number = 25;
  pagerSettings: PagerSettings;

  canGenerateBenchTemplate: boolean = false;
  requiresShippingMethod: boolean = false;

  stateSelect = new StateSelect("stateId", "State", null);

  isAdmin: boolean;

  public selectableSettings: SelectableSettings = { mode: "multiple", drag: true };
  constructor(private activatedRouter: ActivatedRoute,
              private router: Router,
              private auth: AuthenticationService,
              private cd: ChangeDetectorRef,
              private clipboard: Clipboard,
              private feedback: FeedbackMessageService,
              private windowService: WindowService,
              private getServices: GetOrganizationServicesService,
              private notificationService: INotificationService,
              private orderService: RedeploymentOrderService) {
    super();

    this.name = "Redeployment Order";
    this.apiController = "RedeploymentOrder";
    this.keyFieldName = "id";
    this.breadCrumbPropertyNames = ["orderNumber"];
    this.updateOrderPermission = this.auth.canPerformAction(Permission.UpdateOrders);
    this.updateTrackingNumbers = this.auth.canPerformAction(Permission.CreateUpdateTrackingNumbers);
    this.canCancelOrder = this.auth.canPerformAction(Permission.CancelOrder);
    this.canShipOrder = this.auth.canPerformAction(Permission.MarkOrderAsShipped);
    this.initializeUiControls();

    this.activatedRouter.params.subscribe(params => this.id = params['id']);

  }

  ngOnInit(): void {
    var session = this.auth.getSession();
    this.isAdmin = this.auth.isAdmin();
    this.stateSelect.clearDataOnOpen = true;

    this.pagerSettings = {
      previousNext: true,
      position: "bottom",
      info: true,
      type: "input",
      pageSizes: [25, 50, 100, 500]
    };

    var copyText: ContextMenuItem = {
      title: "Copy Text",
      iconClass: clipboardIcon,
      action: this.copyText.bind(this),
    }

    var copyUniqnums: ContextMenuItem = {
      title: "Copy Uniqnums",
      iconClass: clipboardIcon,
      action: () => { this.copyUniqnums(); }
    }

    this.contextMenuItems.push(copyText, copyUniqnums);
  }

  onCountryChange(args: OnChangeArgs): void {
    var filters: StateFilter = {
      countryId: args.value.id
    };
    this.stateSelect.filters = filters;
    this.cd.detectChanges();
  }

  entityLoaded(): void {
    if (this.entity) {
      var session = this.auth.getSession();

      this.itemUniqnumList = this.entity.uniqnumList;

      if (this.entity.organizationId != session?.organizationId) {
        throwError(() => new Error('You are not allowed to view this due to organization'));

        this.router.navigate(['']);
        this.notificationService.show({ title: "Error!", type: "error", description: "You are not allowed to view this due to organization" });
      }
      //If the user is not an admin nor a client admin, let them see all the orders in the organiation
      if (this.auth.isAdmin() || this.auth.canPerformAction(Permission.ViewAllOrders)) {
      } else {
        if (session?.userId != this.entity.whoCreated) {

          this.router.navigate(['']);
          this.notificationService.show({ title: "Error!", type: "error", description: "You are not allowed to view this order." });
        }
      }

      var stateFilters: StateFilter = {
        countryId: this.entity.countryId
      };

      this.stateSelect.filters = stateFilters;

      var toolbarAddItems: ToolbarItem = {
        text: 'Add Item(s)',
        icon: faPlus,
        hasMultiple: false,
        cssClass: "greenDarkBg",
        action: () => { this.addItemsToOrder(); }
      };

      var toolbarRemoveItems: ToolbarItem = {
        text: 'Remove Item(s)',
        icon: faRemove,
        hasMultiple: false,
        cssClass: "danger",
        action: () => { this.removeItemsFromOrder(); }
      };

      //if (this.auth.isAdmin() == true && this.entity.projectOrReturnOrder != null && this.entity.projectOrReturnOrder.fulfillmentOrderID != null && this.entity.projectOrReturnOrder.fulfillmentOrderID != "") {
      //  this.toolbarItems.push(toolbarAddItems);
      //  this.toolbarItems.push(toolbarRemoveItems);
      //}

      try {

        this.getServices.getServicesByCurrentOrganization()
          .subscribe({
            next: (data) => {
              this.requiresShippingMethod = Object(data)[Number(Services.ShippingMethodRequired)];
              //this.canGenerateBenchTemplate = Object(data)[Number(Services.GenerateBenchTemplate)];

              if (!this.requiresShippingMethod) {
                //if we don't have any componets then remove the detail card
                var removeReturnedAssets = this.views.findIndex(x => x.title == "Returning Asset Serial Numbers");
                this.views.splice(removeReturnedAssets, 1);
              }

              if (Object(data)[Number(Services.GenerateBenchTemplate)] == true && this.auth.canPerformAction(Permission.UpdateBenchTemplate) && this.entity.createLabServices) {


                var toolbarGoToBenchTemplate: ToolbarItem = {
                  text: 'Bench Template',
                  icon: faCircleArrowRight,
                  hasMultiple: false,
                  cssClass: "btnGoToBenchTemplate",
                  action: () => { this.redirectToBenchTemplate(); }
                };

                var items = this.toolbarItems;
                this.toolbarItems = [];
                for (var i = 0; i < items.length; i++) {
                  this.toolbarItems.push(items[i]);
                }
                this.toolbarItems.push(toolbarGoToBenchTemplate);
              }
            }
          });
      } catch (err) {
        console.log(err);
      }
    }

    var toolbarRequestToCancel: ToolbarItem = {
      text: 'Request to Cancel',
      icon: faCancel,
      hasMultiple: false,
      cssClass: "redLightBg",
      action: () => { this.sendRequestToCancel(); }
    };
    
    //Only show the sub items if they have permission and the order is neither shipped nor cancelled
    var toolbarSetStatuses: ToolbarItem = {
      text: "Set Status",
      hasMultiple: true,
      iconClass: 'i-i-check',
      cssClass: "purpleBg",
      items: []
    };

    var shipBtn: SubToolbarItem = {
      text: "Ship",
      icon: faShippingFast,
      bgColor: "purple",
      action: () => { this.openShipConfirmDialog(); }
    };

    var cancelBtn: SubToolbarItem = {
      text: "Cancel",
      icon: faCancel,
      bgColor: "red",
      action: () => { this.openCancelConfirmDialog(); }
    };

    var reOpenBtn: SubToolbarItem = {
      text: "Re-Open",
      icon: faCheck,
      bgColor: "green",
      action: () => { this.reOpenOrder(); }
    };

    //Only be able to Ship if the order is opened
    if (this.entity.statusId == Number(RedeploymentOrderStatus.Open) && this.entity.isActive == true && this.canShipOrder) {
      toolbarSetStatuses.items?.push(shipBtn);
    }

    //Only be able to Cancel if the order is opened or pending cancelation
    if ((this.entity.statusId == Number(RedeploymentOrderStatus.Open) || this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation)) && this.entity.isActive == true && this.canCancelOrder) {
      toolbarSetStatuses.items?.push(cancelBtn);
    }

    //Only be able to re-open the order
    if (this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) && this.entity.isActive == true && this.canCancelOrder) {
      toolbarSetStatuses.items?.push(reOpenBtn);
    }


    var items = this.toolbarItems;
    this.toolbarItems = [];

    //If the order is cancelled, remove any toolbar options!
    if ((this.entity.statusId == Number(RedeploymentOrderStatus.Open) && this.entity.isActive == true) || this.auth.isAdmin()) {
      for (var i = 0; i < items.length; i++) {
        this.toolbarItems.push(items[i]);
      }
    }
    if (toolbarSetStatuses.items?.length != 0) {
      this.toolbarItems.push(toolbarSetStatuses)
    }
    if ((this.entity.statusId == Number(RedeploymentOrderStatus.Open) && this.entity.isActive == true)) {
      this.toolbarItems.push(toolbarRequestToCancel);
    }
  }

  isNew() {
    return this.id == "0";
  }

  newOrder() {
    this.router.navigate(['/RedeploymentOrder/NewOrder']);
  }

  redirectToBenchTemplate() {
    this.router.navigate(['/BenchTemplate/Detail/' + this.entity.benchTemplateId]);
  }

  openShipConfirmDialog() {
    this.openShipDialog = true;
  }

  openCancelConfirmDialog() {
    this.openCancelDialog = true;
  }

  closeCancelConfirmDialog() {
    this.openCancelDialog = false;
  }

  closeShipConfirmDialog() {
    this.openShipDialog = false;
  }

  public sendRequestToCancel(): void {
    //Show Cancel text box

    var event = window.event;
    event?.preventDefault();

    let x = window.scrollX;
    let y = window.scrollY;

    window.onscroll = () => {
      window.scrollTo(x, y);
    }

    setTimeout(() => {
      window.onscroll = () => { };
    });

    var options: WindowSettings = {
      title: 'Request Order Cancelation',
      width: 800,
      height: 400,
      content: CancelRequestComponent,
      draggable: true,
      resizable: true,
      top: 200
    };

    const win = this.windowService.open(options);

    const componentData = win.content.instance;

    win.result.subscribe((result) => {
      console.log(result);
    });

    win.content.instance.submitForm.subscribe((formData: FormGroup) => {
      // Save entity
      var entity = formData.value;

      this.orderService.sendCancelRequest(Number(this.id), entity.message).subscribe((result: BooleanResult) => {
        if (result.wasSuccessful) {
          this.feedback.give({ text: "This order has been requested to be cancelled!", status: "success" });
          setTimeout(() => { window.location.reload() }, 1000); 
        } else {
          this.feedback.give({ text: result.message ?? "Error!", status: "error" });
        }
      });
        win.close();
    });

  }

  public cancelOrder(): void {
    this.dialogLoader = true;
    this.dialogIcon = false;

    this.orderService.cancelOrder(Number(this.id)).subscribe((data => {
      if (data.wasSuccessful) {
        this.openCancelDialog = false;
        this.feedback.give({ text: "The order has been canceled.", status: "success" });
        setTimeout(() => { window.location.reload() }, 1000);

      } else {
        this.openCancelDialog = false;
        this.feedback.give({ text: "Error! " + data.message, status: "error" });
      }
    }));
  }

  public reOpenOrder(): void {
    this.orderService.reOpenOrder(Number(this.id)).subscribe((data => {
      if (data.wasSuccessful) {
        this.feedback.give({ text: "The order has been re opened!", status: "success" });
        setTimeout(() => { window.location.reload() }, 1000);

      } else {
        this.openCancelDialog = false;
        this.feedback.give({ text: "Error! " + data.message, status: "error" });
      }
    }));
  }

  public shipOrder(): void {
    this.dialogLoader = true;
    this.dialogIcon = false;

    this.orderService.shipOrder(Number(this.id)).subscribe((data => {
      if (data.wasSuccessful) {
        this.openShipDialog = false;
        this.feedback.give({ text: "The order has been marked shipped!", status: "success" });
        setTimeout(() => { window.location.reload() }, 1000);

      } else {
        this.openShipDialog = false;
        this.feedback.give({ text: "Error! " + data.message, status: "error" });
      }
    }));
  }

  preSave(formControls: { [k: string]: FormControl }): void {
    var organizationId = this.auth.getOrganizationId();
    formControls['organizationId'] = new FormControl(organizationId);

    //We are not showing this on the order page but we still need to save it on the form
    formControls['shippingMethodId'] = new FormControl(this.entity.shippingMethodId);
  }

  onCellClicked(e: CellClickEvent): void {
    this.selectedRow = e.dataItem;

    // Handle Row Selection
    // We need to do custom row selection logic because selecting a row by right-click is not supported.
    // This will handle single row selection, and multi selection using the shift key or ctrl key.
    if (e.rowIndex != undefined) {
      var firstRowIndex = this.lastSelectedRowIndex;
      var lastRowIndex = e.rowIndex;

      var rightClick = window.event !== undefined && (window.event as PointerEvent).which == 3;
      var multiSelectWithCtrl = this.lastPointerEvent != null && this.lastPointerEvent.ctrlKey;
      var multiSelectWithShift = this.lastPointerEvent != null && this.lastPointerEvent.shiftKey;

      if (this.lastPointerEvent == undefined && window.event !== undefined && window.event instanceof PointerEvent) {
        this.lastPointerEvent = window.event;
      }

      if (rightClick) {
        if (!this.mySelection.includes(lastRowIndex)) {
          this.mySelection.push(lastRowIndex);
        }
      } else if (multiSelectWithShift) {
        var selectedIndexes = this.range(firstRowIndex, lastRowIndex);
        this.mySelection = [];
        Array.prototype.push.apply(this.mySelection, selectedIndexes);
      } else if (multiSelectWithCtrl) {
        this.mySelection.push(lastRowIndex);
      } else {
        this.mySelection = [];
        this.mySelection.push(lastRowIndex);
      }
    }

    this.lastSelectedRowIndex = e.rowIndex;
    this.lastSelectedColumnName = e.column.field;
    this.lastSelectedItem = e.dataItem;

    if (e.type == "contextmenu") {
      e.originalEvent.preventDefault();

      this.gridContextMenu.show({
        left: e.originalEvent.pageX,
        top: e.originalEvent.pageY
      });
    }
  }

  copyUniqnums() {
    var itemCount = this.itemUniqnumList.map(e => e.uniqnum).join(",");
    this.clipboard.copy(itemCount);
  }

  private range(start: number, end: number): number[] {
    if (end > start) {
      return Array
        .apply(null, Array((end - start) + 1))
        .map(function (_, n) { return n + start; });
    } else {
      return Array
        .apply(null, Array((start - end) + 1))
        .map(function (_, n) { return n + end; });
    }
  }


  onContextMenuSelect(e: ContextMenuSelectEvent) {
    if (e.item && e.item.data.action) {
      e.item.data.action(e.item.data.params);
    }
  }

  copyText(): void {
    var value: string = "";
    if (this.lastSelectedItem && this.lastSelectedColumnName) {
      value = this.lastSelectedItem[this.lastSelectedColumnName];
    }

    this.clipboard.copy(value);
  }

  addItemsToOrder() {
    var e = window.event;
    e?.preventDefault();

    var settings: WindowSettings = {
      title: 'Add Items',
      width: 550,
      height: 300,
      content: AddItemsComponent,
      draggable: true,
      resizable: false
      //top: 400
    };

    const win = this.windowService.open(settings);
    win.content.instance.id = this.entity.id;

    win.content.instance.submitForm.subscribe((formData: any) => {
      var data = formData.value;

      this.orderService.addItemToOrder(Number(this.id), data.availableItems, Number(this.entity.projectOrReturnOrder.fulfillmentOrderID)).subscribe((data => {
        if (data.wasSuccessful) {
          this.notificationService.show({ type: 'success', title: "Success", description: "Success!" });
          setTimeout(() => { window.location.reload() }, 1000);
        } else {
          this.notificationService.show({ type: 'error', title: "Error", description: data.message ?? "Something Went Wrong!" });
        }

        win.close();
      }));
    });

  }

  removeItemsFromOrder() {
    var e = window.event;
    e?.preventDefault();

    var settings: WindowSettings = {
      title: 'Remove Items',
      width: 550,
      height: 300,
      content: RemoveItemsComponent,
      draggable: true,
      resizable: false
      //top: 400
    };

    const win = this.windowService.open(settings);
    win.content.instance.id = this.entity.id;

    win.content.instance.submitForm.subscribe((formData: any) => {
      var data = formData.value;

      this.orderService.removeItemFromOrder(Number(this.id), data.itemsOnOrder, Number(this.entity.projectOrReturnOrder.fulfillmentOrderID)).subscribe((data => {
        if (data.wasSuccessful) {
          this.notificationService.show({ type: 'success', title: "Success", description: "Success!" });
          setTimeout(() => { window.location.reload() }, 1000);
        } else {
          this.notificationService.show({ type: 'error', title: "Error", description: data.message ?? "Something Went Wrong!" });
        }

        win.close();
      }));
    });

  }

  override initializeUiControls() {
    var isReadonly = !this.updateOrderPermission;

    const notesCard = new ViewControl("Notes");
    const trackingCard = new ViewControl("Tracking Information");
    const assetSerialsCard = new ViewControl("Returning Asset Serial Numbers");
    const additionalEmailsCard = new ViewControl("Additional Emails");
    const customerDetailCard = new ViewControl("Shipping Information");
    const redeploymentOrderItemsDetailCard = new ViewControl("Products");

    const notesDetails = new UiGroupControl("", "SKU Details");
    const trackingDetails = new UiGroupControl("", "Tracking Details");
    const assetSerialsDetails = new UiGroupControl("", "Returning Asset Serial Number Details");
    const additionalEmailsDetails = new UiGroupControl("", "Additional Emails Details");
    const customerDetails = new UiGroupControl("", "Item Details");
    const redeploymentOrderItemsDetails = new UiGroupControl("", "Component Details");

    const notes = new EditorControl("notes", "Notes", "", false);

    const trackingNumber = new ListBoxControl("trackingNumber", "Tracking Numbers", new Array<any>);

    const assetSerial = new ListBoxControl("returningAssetSerial", "Returning Asset Serial Numbers", new Array<any>);

    const additionalEmails = new ListBoxControl("additionalEmail", "Additional Emails", new Array<any>);

    const packageRecipientEmail = new TextControl("packageRecipientEmail", "Package Recipient Email", "");
    packageRecipientEmail.addOption(new RequiredIf(() => {
      return true;
    }));

    const recipientPhone = new TextControl("recipientPhone", "Package Recipient Phone", "");
    recipientPhone.addOption(new RequiredIf(() => {
      return true;
    }));

    const company = new TextControl("company", "Company (optional)", "");

    const firstName = new TextControl("firstName", "First Name", "");
    firstName.addOption(new RequiredIf(() => {
      return true;
    }));

    const lastName = new TextControl("lastName", "Last Name", "");
    lastName.addOption(new RequiredIf(() => {
      return true;
    }));

    const line1 = new TextControl("line1", "Address", "");
    line1.addOption(new RequiredIf(() => {
      return true;
    }));

    const line2 = new TextControl("line2", "Apartment, suite, stc. (optional)", "");

    const city = new TextControl("city", "City", "");
    city.addOption(new RequiredIf(() => {
      return true;
    }));

    const postalCode = new TextControl("postalCode", "Postal Code", "");
    postalCode.addOption(new RequiredIf(() => {
      return true;
    }));

    this.stateSelect = new StateSelect("stateId", "State", null);
    this.stateSelect.addOption(new RequiredIf(() => {
      return true;
    }));

    const countrySelect = new CountrySelect("countryId", "Country", null);
    countrySelect.onchange = (args: OnChangeArgs) => { this.onCountryChange(args); }
    countrySelect.addOption(new RequiredIf(() => {
      return true;
    }));

    notes.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    packageRecipientEmail.addOption(new ReadOnlyIf(() => {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    recipientPhone.addOption(new ReadOnlyIf(() => {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    company.addOption(new ReadOnlyIf(() => {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
        this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
        this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
        this.entity.isActive == false ||
        isReadonly) : false;
    }));

    firstName.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    lastName.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    line1.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    line2.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    city.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
        this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
        this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    postalCode.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    this.stateSelect.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    countrySelect.addOption(new ReadOnlyIf(() =>
    {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Shipped) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly) : false;
    }));

    var countryFilter: CountryFilter = {
      organizationId: this.auth.getOrganizationId()
    };

    countrySelect.filters = countryFilter;

    trackingNumber.addOption(new ReadOnlyIf(() => {
      return this.entity != undefined ? (this.entity.statusId == Number(RedeploymentOrderStatus.Cancelled) ||
                                         this.entity.statusId == Number(RedeploymentOrderStatus.PendingCancellation) ||
                                         this.entity.isActive == false ||
                                         isReadonly || !this.updateTrackingNumbers) : false;
    }));

    assetSerial.addOption(new ReadOnlyIf(() => {
      return !this.auth.isAdmin();
    }));

    additionalEmails.addOption(new ReadOnlyIf(() => {
      return !this.auth.isAdmin();
    }));

    var redeploymentOrderItemsColumns: UiColumn[] = [
      new UiColumn("product", "Product", 40),
      new UiColumn("sku", "SKU", 40),
      new UiColumn("quantity", "Qty", 10)
    ];

    var redeploymentOrderItemsOptions: TabOptions = {
      name: "redeploymentOrderItems",
      label: "",
      columns: redeploymentOrderItemsColumns,
      apiController: "RedeploymentOrder",
      isDataPreloaded: true,
      showDeleteBtn: false,
      showEditBtn: false
    };

    const redeploymentOrderItems = new GridControl(redeploymentOrderItemsOptions);


    var notesRow = new ViewRowControl();
    notesRow.controls.push(notes);

    var trackingRow = new ViewRowControl();
    trackingRow.controls.push(trackingNumber);

    var assetSerialRow = new ViewRowControl();
    assetSerialRow.controls.push(assetSerial);

    var additionalEmailRow = new ViewRowControl();
    additionalEmailRow.controls.push(additionalEmails);

    var customerRow = new ViewRowControl();
    customerRow.controls.push(packageRecipientEmail, recipientPhone, company, firstName, lastName, line1, line2, city, postalCode, this.stateSelect, countrySelect);

    var redeploymentOrderItemsRow = new ViewRowControl();
    redeploymentOrderItemsRow.controls.push(redeploymentOrderItems);

    notesDetails.rows.push(notesRow);
    notesCard.controls.push(notesDetails);

    trackingDetails.rows.push(trackingRow);
    trackingCard.controls.push(trackingDetails);

    assetSerialsDetails.rows.push(assetSerialRow);
    assetSerialsCard.controls.push(assetSerialsDetails);


    additionalEmailsDetails.rows.push(additionalEmailRow);
    additionalEmailsCard.controls.push(additionalEmailsDetails);


    customerDetails.rows.push(customerRow);
    customerDetailCard.controls.push(customerDetails);

    redeploymentOrderItemsDetails.rows.push(redeploymentOrderItemsRow);
    redeploymentOrderItemsDetailCard.controls.push(redeploymentOrderItemsDetails);


    this.views.push(redeploymentOrderItemsDetailCard, notesCard, trackingCard, additionalEmailsCard, assetSerialsCard, customerDetailCard);
  }

}




